<div class="input-page">
  <div class="container">
    <mm-transaction-form
      [palAccountInContext]="palAccountInContext"
      (showTweModal)="showTweModalEvent($event)"
      (showTemplateModal)="showTemplateModalEvent($event)"
      (showOverdraftRulesPopup)="showOverdraftRulesPopupEvent($event)"
      (formHasBeenStarted)="formHasBeenStartedEvent($event)">
    </mm-transaction-form>
    <mm-transactions-table [showCancelModalOnClick]="(formStartedStatusObs$ | async)!"></mm-transactions-table>
    <mm-standing-authorizations-table *ngIf="!palAccountInContext" [showCancelModalOnClick]="(formStartedStatusObs$ | async)!"></mm-standing-authorizations-table>
    <mm-recurring-transactions-table [showCancelModalOnClick]="(formStartedStatusObs$ | async)!"></mm-recurring-transactions-table>
  </div>
</div>
